import { combineReducers } from 'redux';
import appConfig from './appConfig';
import userInfo from './userInfo';
import utilities from './utilities';

export default combineReducers({ appConfig, userInfo, utilities });



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js